import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import SupportApi from '../../Api/supportApi';
// import { stream } from "xlsx/types";
import { MENU_TYPE, MENU_INFO, HEADER_TYPE } from '../../../../Utils/enums';
import date from '../../../../Utils/Date';
import Func from '../../../../Utils/func';
import CommonApi from '../../Api/commonApi';
import {
  setProgressBar,
  setSnackBar,
  closeSnackBar,
  setDialog,
  movePage,
  setMenuType,
  getCode,
  initCheckElement,
  initInvoice,
  initState,
  getInvoice,
  getInvoiceTemp,
  getInvoicePos,
  getInvoiceList,
  getInvoicePosList,
  setInvoiceList,
  getInvoiceListTotalAmout,
  getInvoicePosListTotalAmout,
  getIssueInvoiceDetail,
  objectStorageDownload,
} from './Common';
import taker from './taker';

/**
 * [Advisory] 공지사항 목록 조회
 * @param {*} param
 */
export function* getAdvisoryList({ payload }) {
  const response = yield call(SupportApi.getAdvisoryList, payload);

  let advisoryList = [];

  if (response.status === 200) {
    advisoryList = response.data;
    advisoryList.content.map((advisory) => {
      advisory.insertTimestamp = date.dateTimestampConvert(
        advisory.insertTimestamp
      );
    });
  }

  yield put(Action.getAdvisoryList.success(advisoryList));
}

/**
 * [Advisory] 공지사항 상세 정보 조회
 * @param {*} param
 */
export function* getAdvisoryDetail({ payload }) {
  const response = yield call(SupportApi.getAdvisoryDetail, payload);

  if (response.status !== 200 || !response.data.advisoryNo) {
    Func.moveExUrl(MENU_INFO['support_0'].mainURL, null);
    return;
  } else {
    yield put(Action.getAdvisoryDetail.success(response.data));
  }
}

/**
 * [Advisory] 공지사항 추가
 * @param {*} param
 */
export function* insertAdvisoryList({ payload }) {
  const [...responses] = yield all([
    ...payload.fileList.map((file) =>
      call(CommonApi.setObjectStorageUpload, {
        file: file,
        bucket: 'eis',
      })
    ),
  ]);

  responses.map((res) => {
    const file = res.file;

    payload.advisoryDtoList[0] = {
      ...payload.advisoryDtoList[0],
      advisoryFileDtoList:
        payload.advisoryDtoList[0].advisoryFileDtoList.concat({
          fileName: res.fileName,
          originalFileName: file.name,
          fileSize: file.size,
          deleteYn: 'N',
        }),
    };
  });

  const response = yield call(SupportApi.setAdvisory, payload.advisoryDtoList);

  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Advisory Save Success',
        open: true,
        type: 'success',
      },
    });
    Func.moveExUrl(MENU_INFO['support_0'].mainURL, null);
  }
}

export function* getMainAdvisoryList({ payload }) {
  try {
    const response = yield call(SupportApi.getAdvisoryList, payload);

    let advisoryList = [];

    if (response.status === 200) {
      advisoryList = response.data;
      advisoryList.content.map((advisory) => {
        advisory.insertTimestamp = date.dateTimestampConvert(
          advisory.insertTimestamp
        );
      });
    }

    yield put(Action.getAdvisoryList.success(advisoryList));
  } catch (error) {}
}
/********************************************************************************/

/**
 * [Board] Board List 조회
 * @param {*} param
 */
export function* getBoardList({ payload }) {
  const response = yield call(SupportApi.getBoardPostList, payload);

  let boardList = {};

  if (response.status === 200) {
    boardList = response.data;
  }

  yield put(Action.getBoardList.success(boardList));
}

/**
 * [Board] FAQ 상세 조회
 * @param {*} param
 */
export function* getBoardDetail({ payload }) {
  const response = yield call(SupportApi.getBoardPostDetail, payload);

  if (response.status !== 200 || !response.data.boardPostNo) {
    Func.moveExUrl(MENU_INFO['support_1'].mainURL, null);
  } else {
    yield put(Action.getBoardDetail.success(response.data));
  }
}

/**
 * [Board] BoardPost 추가
 * @param {*} param
 */
export function* insertBoardPostList({ payload }) {
  if (payload.fileList != undefined) {
    const [...responses] = yield all([
      ...payload.fileList.map((file) =>
        call(CommonApi.setObjectStorageUpload, {
          file: file,
          bucket: payload.bucket,
        })
      ),
    ]);

    responses.map((res) => {
      const file = res.file;

      payload.boardPostDtoList[0] = {
        ...payload.boardPostDtoList[0],
        boardPostFileDtoList:
          payload.boardPostDtoList[0].boardPostFileDtoList.concat({
            fileName: res.fileName,
            originalFileName: file.name,
            fileSize: file.size,
            deleteYn: 'N',
          }),
      };
    });
  }

  const response = yield call(
    SupportApi.setBoardPost,
    payload.boardPostDtoList
  );

  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Board Post Save Success',
        open: true,
        type: 'success',
      },
    });

    Func.moveExUrl(MENU_INFO['support_1'].mainURL, null);
  }
}

export default [
  takeLatest(Action.getAdvisoryList.TRIGGER, taker(getAdvisoryList)),
  takeLatest(Action.getAdvisoryDetail.TRIGGER, taker(getAdvisoryDetail)),
  takeLatest(Action.insertAdvisoryList.TRIGGER, taker(insertAdvisoryList)),
  takeLatest(Action.getMainAdvisoryList.TRIGGER, taker(getMainAdvisoryList)),

  takeLatest(Action.getBoardList.TRIGGER, taker(getBoardList)),
  takeLatest(Action.getBoardDetail.TRIGGER, taker(getBoardDetail)),
  takeLatest(Action.insertBoardPostList.TRIGGER, taker(insertBoardPostList)),
];
